module.exports = __webpack_public_path__ + "static/media/circle-carousel.af61ef2e.svg";